module.exports = __webpack_public_path__ + "img/vegetable-avocados-350x184.11a39241.jpg";